import {ILoggerService, LogError} from './logger.service.interface';

enum LOG_LEVELS {
    DEBUG = 1,
    INFO = 2,
    WARN =3,
    ERROR = 4
}

export class ConsoleLoggerService implements ILoggerService {

  constructor(private _debugMode: boolean) {

  }

  errorLogs: LogError[] = [];

  debug(message: string, ...optionalParams: any[]): void {
    this._log('debug', message, optionalParams);
  }

  info(message: string, ...optionalParams: any[]): void {
    this._log('info', message, optionalParams);
  }

  warning(message: string, ...optionalParams: any[]): void {
    this._log('warn', message, optionalParams);
  }

  error(message: string, ...optionalParams: any[]): void {
    this._addErrorLog(message, optionalParams);

    this._log('error', message, optionalParams);
  }


  /**
   * Private method, provides single point of access to the "console.log" API.
   * Prevents mess around the code and a clean way to prevent the output of the log or the severity level.
   */
  private  _log(severity: string, message: string, ...optionalParams: any[]) {
    if (this._isConsoleEnabled(severity.toUpperCase())) {
      console[severity](message, optionalParams);
    }
  }

  private _isConsoleEnabled(severity: string): boolean {
    return  LOG_LEVELS[severity] >= LOG_LEVELS[window['LOG_LEVEL']]
  }

  private _addErrorLog(message: string, ...optionalParams: any[]) {
    if(!this._debugMode) {
      return;
    }

    if (this.errorLogs.length === 30) {
      this.errorLogs.splice(0, 1);
    }

    this.errorLogs.push({message: message, date: new Date(), errorDetails: optionalParams});
  }

}
